import axios, { AxiosRequestConfig } from "axios";
import imageCompression from "browser-image-compression";
import { authTokenVar, UPLOAD_URI } from "../apollo";

const headers: AxiosRequestConfig["headers"] = {
  "mfc-jwt": authTokenVar() || "",
};

export const upload = async (event: any) => {
  let data = new FormData();
  let file = event.target.files[0];
  const options = {
    maxSizeMB: 1,
    useWebWorker: true,
  };
  try {
    const compressedFile = await imageCompression(file, options);
    data.append("file", compressedFile);
  } catch (error) {
    console.log(error);
    alert("파일 업로드에 실패하였습니다.");
  }

  const config = {
    headers,
    // 이걸 어떻게 가져오냐!
    onUploadProgress: (progressEvent: any) => {
      return Math.round((100 * progressEvent.loaded) / progressEvent.total);
    },
  };
  return await axios.post(UPLOAD_URI, data, config);
};

export const uploadDetailImage = async (file: any) => {
  let data = new FormData();
  data.append("file", file);
  const config = {
    headers,
  };
  return await axios.post(UPLOAD_URI, data, config);
};
